export enum UploadingSteps {
  UPLOAD_FILE = 'UPLOAD_FILE',
  STOCK_FILE_OPTIONS = 'STOCK_FILE_OPTIONS',
  SELECT_OPTIONS = 'SELECT_OPTIONS',
  FAILED_TO_IDENTIFY = "FAILED_TO_IDENTIFY"    // IF RESPONSE IS NOT 400
}
